<template>
  <section class="about">
    <v-layout wrap class="hidden-sm-and-down">
      <v-flex md12 class="top-breadcrumbs">
        <v-container grid-list-md>
          <v-layout>
          <v-breadcrumbs :items="breadcrumbs" divider=" / "></v-breadcrumbs>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-container>
      <v-layout wrap mb-12>
        <v-flex xs12 sm12 md12 lg12 mt-12 mb-12>
          <h3 class="h3-title">空间色彩搭配</h3>
          <p class="color-p" style="max-width: 730px;">中国流行色协会家居色彩研究院是玛娅家居战略合作伙伴，使德国玛雅家居时刻走在家居色彩流行前沿，不断推出更具前瞻性和创新性的花色及产品，为用户提供家居产品配色解决方案， 为客户打造更有装饰性和个人特色的家居空间。</p>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 mb-4>
          <h3 class="color-h3">宗旨与愿景</h3>
          <p class="color-p">中国流行色协会家居色彩研究院是玛娅战略合作伙伴，为用户提供优质睡眠环境空间色彩搭配解决方案。中国流行色协会家居色彩研究院专注于研究家居色彩与设计，秉承先进的国际色彩理念与成果，面向泛家居领域企业和从业者提供专业的色彩服务；面向家居全产业链和消费者分享色彩与设计资讯，引导更多人关注家居色彩、享受家居色彩之美。正确的颜色，让生活更美好！</p>
          <v-layout wrap mt-12>
            <div style="max-width:850px;">
              <v-layout wrap>
                <v-flex xs12 sm12 md7 lg7 mb-4 pr-md-12>
                  <img class="content-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/1.png" style="max-width:1080px;margin:0 auto;"/>
                </v-flex>
                <v-flex xs12 sm12 md5 lg5 mt-4 text-center>
                  <div style="max-width:380px; text-align: center;margin:0 auto;">
                    <v-layout>
                      <v-flex xs6 sm6 md6 lg6 text-center>
                        <img class="content-img qr-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/2-1.png"/>
                        <p class="qr-p">微信公众号</p>
                      </v-flex>
                      <v-flex xs6 sm6 md6 lg6 text-center>
                        <img class="content-img qr-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/2-2.png"/>
                        <p class="qr-p">微信视频号</p>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-flex xs12 sm12 md12 lg12 mt-4>
              <p class="color-p">中国流行色协会家居色彩研究院由中国流行色协会和德硅集团联合创立，致力于推动中国家居行业色彩事业发展，研究家居色彩流行趋势、色彩新课题，提供专业色彩培训、配色解决方案、色彩营销等服务，分享国际前沿色彩趋势、行业研究成果，举办校园、社区等公益讲座，以及发起或参与色彩相关的项目孵化。</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout wrap class="color-bg">
        <v-container grid-list-md>
        <v-flex xs12 sm12 md12 lg12 pt-6>
          <h3 class="color-h3">核心团队</h3>
          <v-layout wrap style="max-width: 1288px;">
            <v-flex xs12 sm12 md4 mb-12 lg4 pr-2 class="color-hxtd-div">
              <div class="color-hxtd">
                <img class="content-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/3-1.png"/>
                <p class="color-hxtd-name">程慧玲</p>
                <p class="color-hxtd-desc">家居色彩研究院院长</p>
                <p class="color-hxtd-desc">中国流行色协会副会长</p>
                <p class="color-hxtd-desc">中国家居装饰色彩研发基地创建者</p>
                <p class="color-hxtd-desc">德硅集团董事长</p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4 mb-12 pl-2 pr-2 class="color-hxtd-div">
              <div class="color-hxtd">
                <img class="content-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/3-2.png"/>
                <p class="color-hxtd-name">Monika Haag</p>
                <p class="color-hxtd-desc">家居色彩研究院顾问</p>
                <p class="color-hxtd-desc">色彩之旅创始人</p>
                <p class="color-hxtd-desc">色彩营销集团CMG亚太区董事</p>
                <p class="color-hxtd-desc">雷诺丽特设计管理部总经理</p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4 mb-12 pl-2 class="color-hxtd-div">
              <div class="color-hxtd">
                <img class="content-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/3-3.png"/>
                <p class="color-hxtd-name">沈晓莲</p>
                <p class="color-hxtd-desc">家居色彩研究院副院长</p>
                <p class="color-hxtd-desc">色彩之旅全球色彩大使</p>
                <p class="color-hxtd-desc">CMG亚太区色彩预测引导师</p>
                <p class="color-hxtd-desc">德硅·雷诺丽特  品牌总监</p>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md8 lg8 class="hidden-sm-and-down">
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 mt-12>
          <h3 class="color-h3">专家顾问团</h3>
          <v-layout wrap mt-6>
            <v-flex xs12 sm12 md4 mb-12 lg4 pr-1 class="color-zjgw-div">
              <div class="color-zjgw" style="background:url(https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/4-1.png) no-repeat left center;">
                <div>
                  <p class="color-zjgw-name">朱莎</p>
                  <p class="color-zjgw-desc">中国流行色协会会长</p>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4 mb-12 lg4 pl-1 pr-1 class="color-zjgw-div">
              <div class="color-zjgw" style="background:url(https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/4-2.png) no-repeat left center;">
                <div>
                  <p class="color-zjgw-name">许柏鸣</p>
                  <p class="color-zjgw-desc">深圳家具研究开发院院长/</p>
                  <p class="color-zjgw-desc">南京林业大学家具设计与工程学院教授&</p>
                  <p class="color-zjgw-desc">博士生导师/</p>
                  <p class="color-zjgw-desc">国家公派米兰理工大学访问学者</p>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4 mb-12 lg4 pl-1 class="color-zjgw-div">
              <div class="color-zjgw" style="background:url(https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/4-3.png) no-repeat left center;">
                <div>
                  <p class="color-zjgw-name">关永康</p>
                  <p class="color-zjgw-desc">深圳家协住宅精装研究院院长/</p>
                  <p class="color-zjgw-desc">优舍住宅产业科技董事长/</p>
                  <p class="color-zjgw-desc">深圳国际精装住宅展发起人&总策展人</p>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4 mb-12 lg4 pr-1 class="color-zjgw-div">
              <div class="color-zjgw" style="background:url(https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/4-4.png) no-repeat left center;">
                <div>
                  <p class="color-zjgw-name">黄晓靖</p>
                  <p class="color-zjgw-desc">YANG DESIGN设计策略研究所合伙人&策略总监/</p>
                  <p class="color-zjgw-desc">《中国设计趋势报告》主编</p>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4 mb-12 lg4 pl-1 pr-1 class="color-zjgw-div">
              <div class="color-zjgw" style="background:url(https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/4-5.png) no-repeat left center;">
                <div>
                  <p class="color-zjgw-name">周平</p>
                  <p class="color-zjgw-desc">上海松果设计董事长/</p>
                  <p class="color-zjgw-desc">沉浸式文化与色彩感官餐厅“良设夜宴”创始人/</p>
                  <p class="color-zjgw-desc">上海工业设计协会副会长</p>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4 mb-12 lg4 pl-1 class="color-zjgw-div">
              <div class="color-zjgw" style="background:url(https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/4-6.png) no-repeat left center;">
                <div>
                  <p class="color-zjgw-name">黄明富</p>
                  <p class="color-zjgw-desc">萨米设计研究总经理/</p>
                  <p class="color-zjgw-desc">CMF设计军团创始人/</p>
                  <p class="color-zjgw-desc">国际CMF设计大会创始人/</p>
                  <p class="color-zjgw-desc">华中科技大学、成都大学、深圳大学外聘教师</p>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        </v-container>
    </v-layout>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 sm12 md12 lg12 mt-12 mb-6>
          <h3 class="color-h3">国际联盟</h3>
        </v-flex>
        <v-flex xs12 sm12 md2 lg2 mb-6 style="display: flex;justify-content: center;align-items: center;">
          <img class="content-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/5.png" style="max-width: 200px;"/>
        </v-flex>
        <v-flex xs12 sm12 md7 lg7 mb-6>
          <v-layout wrap>
            <v-flex xs6 sm6 md3 lg3 mb-6 pr-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/6-1.png" height="120"></v-img>
              <p class="color-lm-p">2015 上海</p>
            </v-flex>
            <v-flex xs6 sm6 md3 lg3 mb-6 pl-2 pr-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/6-2.png" height="120"></v-img>
              <p class="color-lm-p">2016 上海</p>
            </v-flex>
            <v-flex xs6 sm6 md3 lg3 mb-6 pl-2 pr-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/6-3.png" height="120"></v-img>
              <p class="color-lm-p">2017 苏州</p>
            </v-flex>
            <v-flex xs6 sm6 md3 lg3 mb-6 pl-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/6-4.png" height="120"></v-img>
              <p class="color-lm-p">2018 上海</p>
            </v-flex>
            <v-flex xs6 sm6 md3 lg3 mb-6 pr-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/6-5.png" height="160"></v-img>
              <p class="color-lm-p">2019 上海</p>
            </v-flex>
            <v-flex xs6 sm6 md4 lg4 mb-6 pl-2 pr-md-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/6-6.png" height="160"></v-img>
              <p class="color-lm-p">2020 上海（虚拟）</p>
            </v-flex>
            <v-flex xs12 sm12 md5 lg5 mb-6 pl-md-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/6-7.png" height="160"></v-img>
              <p class="color-lm-p">2021 上海（虚拟）</p>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md3 lg3 mb-6 style="display: flex;justify-content: center;align-items: center;">
          <img class="content-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/7.png" style="max-width: 200px;"/>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 mt-12 mb-6>
          <h3 class="color-h3">研究成果--色彩之旅(since 2008)</h3>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 mb-2>
          <v-layout wrap>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-1.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-2.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-3.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-4.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-5.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-6.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-7.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-8.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-9.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-10.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-11.png"></v-img>
            </v-flex>
            <v-flex xs6 sm6 md2 lg2 pa-2>
              <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/8-12.png"></v-img>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 mb-12>
          <h3 style="text-align: center; font-size: 18px; color: #666;">历年趋势报告</h3>
        </v-flex>
        <v-flex xs12 sm12 md8 lg8 mt-6 mb-6>
          <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/9.png"></v-img>
        </v-flex>
        <v-flex xs12 sm12 md4 lg4 mt-6 mb-6 text-center style="display: flex;justify-content: center;align-items: center;">
          <div style="margin:0 auto;">
            <img class="content-img" src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/advantage/color/10.png" style="max-width: 200px !important;"/>
            <p style="font-size: 20px; font-weight: 500; color: #000000;margin-top:20px;">扫码了解趋势工具</p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <back-to-top bottom="60px" right="10px" visibleoffset="1080">
      <v-btn
        color="black"
        class="btn-to-top"
        depressed
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </back-to-top>
  </section>
</template>
<script>

import BackToTop from 'vue-backtotop'
export default {
  components: { BackToTop },
  data: () => ({
    breadcrumbs: []
  }),
  created () {
    this.breadcrumbs = [
      { text: '关于玛娅', disabled: true },
      { text: '空间色彩搭配', disabled: true }
    ]
  },
  computed: {
    info () {
      return this.$store.getters.companyInfo
    }
  },
  methods: {
  }
}
</script>
<style lang="css">
  @import '../css/color.css';
</style>
